'use client';

import { Truck, Clock, ShieldCheck, Headphones } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';

function Counter({ end, suffix = '' }: { end: number; suffix?: string }) {
  const [count, setCount] = useState(end);
  const ref = useRef<HTMLDivElement>(null);
  const hasAnimated = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;
          setCount(0);
          let start = 0;
          const duration = 2000;
          const increment = end / (duration / 16);
          const timer = setInterval(() => {
            start += increment;
            if (start >= end) {
              setCount(end);
              clearInterval(timer);
            } else {
              setCount(Math.floor(start));
            }
          }, 16);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [end]);

  return <span ref={ref}>{count.toLocaleString()}{suffix}</span>;
}

export function FeaturesSection() {
  const features = [
    {
      icon: Truck,
      title: 'All Hyderabad Pincodes',
      description: 'Serving all pincodes in Hyderabad'
    },
    {
      icon: Clock,
      title: '48hr Dispatch',
      description: 'Fast order processing'
    },
    {
      icon: ShieldCheck,
      title: 'Genuine Products',
      description: '100% brand authentic'
    },
    {
      icon: Headphones,
      title: 'Expert Support',
      description: 'Free material consults'
    }
  ];

  return (
    <>
    <section className="bg-foreground py-4 overflow-hidden">
      <div className="container-custom">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-3 md:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="flex items-center gap-3 pl-2 md:px-0">
              <div className="w-9 h-9 rounded-full bg-accent/20 flex items-center justify-center flex-shrink-0">
                <feature.icon className="w-4 h-4 text-accent" />
              </div>
              <div>
                <p className="text-primary-foreground !font-bold text-[12px] lg:text-[14px] font-lexend">
                {feature.title}
              </p>
                <p className="text-primary-foreground/70 text-[10px] md:text-xs hidden md:block">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
</>  
  );
}
